import { jsxs, jsx } from "react/jsx-runtime";
import { ThemeProvider, GlobalStyles } from "@mui/material";
import { muiTheme } from "../theme.js";
import { globalStyles } from "./globalStyles.js";
import fontsCss from "../../fonts/Raleway/fonts.css.js";
/* empty css                                  */
import merge from "../../vendor/lodash-es/merge.js";
const UiKitThemeProvider = ({ children, noParentTheme }) => /* @__PURE__ */ jsxs(
  ThemeProvider,
  {
    theme: noParentTheme ? muiTheme : (theme) => merge({}, theme, muiTheme),
    children: [
      /* @__PURE__ */ jsx(GlobalStyles, { styles: fontsCss }),
      /* @__PURE__ */ jsx(GlobalStyles, { styles: globalStyles }),
      children
    ]
  }
);
export {
  UiKitThemeProvider
};
//# sourceMappingURL=UiKitThemeProvider.js.map
